import { api } from '@/lib/api'
import type {
  BudgetDashboardResponse,
  DashboardSummaryResponse,
  OverviewCustomRange,
  OverviewPeriod,
  PendingTransaction,
} from './types'

export const overviewApi = {
  summary: (period: OverviewPeriod, custom?: OverviewCustomRange, fiscalStartMonth?: number) => {
    const query: Record<string, string> = { period }
    if (period === 'CUSTOM' && custom) {
      query.from = custom.from
      query.to = custom.to
    }
    if (period === 'LFY' && fiscalStartMonth) {
      query.fiscalStartMonth = String(fiscalStartMonth)
    }
    return api.get<DashboardSummaryResponse>('/api/dashboard/summary', { query })
  },
  pendingDetails: () => api.get<PendingTransaction[]>('/api/dashboard/pending-details'),
  budgetSummary: (window?: { from: string; to: string }) => {
    const qs = new URLSearchParams()
    if (window?.from && window?.to) {
      qs.set('from', window.from)
      qs.set('to', window.to)
    }
    const suffix = qs.toString() ? `?${qs.toString()}` : ''
    return api.get<BudgetDashboardResponse>(`/api/budget/dashboard-summary${suffix}`)
  },
}
